import React, { useState, useEffect } from 'react';
import { ref, onValue, update, get } from "firebase/database";
import { db } from "../firebase";
import Swal from 'sweetalert2';
import { Headset, Lock, User, Save } from 'lucide-react';
import './AdminSettings.css';

const AdminSettings = () => {
  const [links, setLinks] = useState({
    whatsapp: '',
    telegram: ''
  });

  const [adminAuth, setAdminAuth] = useState({
    username: '',
    password: ''
  });

  const [oldPasswordInput, setOldPasswordInput] = useState('');

  useEffect(() => {
    const configRef = ref(db, 'adminConfig');
    onValue(configRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const getUsername = (link) => link ? link.split('/').pop() : '';
        setLinks({
          whatsapp: getUsername(data.whatsapp),
          telegram: getUsername(data.telegram)
        });
        setAdminAuth({
          username: data.username || 'tradehouse1',
          password: data.password || '123123'
        });
      }
    });
  }, []);

  const saveLinks = async (e) => {
    e.preventDefault();
    try {
      // Inputs ko clean kar rhe hain takay extra spaces ya domains validate ho sakein
      const cleanWhatsapp = links.whatsapp.trim().replace('https://wa.me/', '');
      const cleanTelegram = links.telegram.trim().replace('https://t.me/', '');

      const finalWhatsapp = `https://wa.me/${cleanWhatsapp}`;
      const finalTelegram = `https://t.me/${cleanTelegram}`;

      await update(ref(db, 'adminConfig'), {
        whatsapp: finalWhatsapp,
        telegram: finalTelegram
      });
      Swal.fire({
        title: 'Success',
        titleText: 'Success',
        text: 'Service links updated!',
        icon: 'success',
        background: '#161616',
        color: '#fff',
        confirmButtonColor: '#f3ba2f'
      });
    } catch (error) {
      Swal.fire('Error', 'Failed to update links', 'error');
    }
  };

  const saveAdminAuth = async (e) => {
    e.preventDefault();
    try {
      const configRef = ref(db, 'adminConfig');
      const snapshot = await get(configRef);
      const dbPassword = snapshot.val()?.password || '123123';

      if (oldPasswordInput !== dbPassword) {
        Swal.fire({
          icon: 'error',
          title: 'Unauthorized',
          text: 'Old password galat hai!',
          background: '#161616',
          color: '#fff'
        });
        return;
      }

      await update(ref(db, 'adminConfig'), {
        username: adminAuth.username,
        password: adminAuth.password
      });

      Swal.fire({
        title: 'Updated',
        text: 'Admin credentials changed successfully!',
        icon: 'success',
        background: '#161616',
        color: '#fff',
        confirmButtonColor: '#ff4d4d'
      });
      setOldPasswordInput('');
    } catch (error) {
      Swal.fire('Error', 'Update failed!', 'error');
    }
  };

  return (
    <div className="settings-container">
      <h2 className="page-title">Global Settings</h2>
      
      <div className="settings-grid">
        {/* SECTION 1: Customer Service */}
        <form onSubmit={saveLinks} className="settings-card">
          <h3><Headset size={20} /> Customer Service</h3>
          
          <div className="input-group">
            <label>WhatsApp Number</label>
            <div className="prefix-input">
              <span className="prefix-tag">wa.me/</span>
              <input 
                type="text" 
                value={links.whatsapp}
                onChange={(e) => setLinks({...links, whatsapp: e.target.value})}
                placeholder="92300..."
              />
            </div>
          </div>

          <div className="input-group">
            <label>Telegram Username</label>
            <div className="prefix-input">
              <span className="prefix-tag">t.me/</span>
              <input 
                type="text" 
                value={links.telegram}
                onChange={(e) => setLinks({...links, telegram: e.target.value})}
                placeholder="username"
              />
            </div>
          </div>

          <button type="submit" className="save-btn-small">
            <Save size={18} /> SAVE LINKS
          </button>
        </form>

        {/* SECTION 2: Admin Authentication */}
        <form onSubmit={saveAdminAuth} className="settings-card security-card">
          <h3><Lock size={20} /> Admin Authentication</h3>
          
          <div className="input-group">
            <label><User size={14} /> New Admin Username</label>
            <input 
              type="text" 
              value={adminAuth.username}
              onChange={(e) => setAdminAuth({...adminAuth, username: e.target.value})}
            />
          </div>

          <div className="input-group">
            <label><Lock size={14} /> New Password</label>
            <input 
              type="password" 
              value={adminAuth.password}
              onChange={(e) => setAdminAuth({...adminAuth, password: e.target.value})}
            />
          </div>

          <div className="divider-line"></div>

          <div className="input-group verify-group">
            <label>VERIFY IDENTITY</label>
            <input 
              type="password" 
              placeholder="Enter old password to confirm"
              value={oldPasswordInput}
              onChange={(e) => setOldPasswordInput(e.target.value)}
              required
              className="verify-input"
            />
          </div>

          <button type="submit" className="save-btn-small auth-btn">
            <Save size={18} /> UPDATE CREDENTIALS
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;